/* eslint-disable react/jsx-no-undef */
import React, { Component } from 'react';
import { Button, Drawer, Grid, TextField, Input, Modal, Typography, FormHelperText, Badge } from '@material-ui/core';
import { DatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import format from 'date-fns/format';
import { connect } from 'react-redux';
import { NotificationManager } from 'react-notifications';
import style from './style';
import { BOOKING_STATUS } from '../../config/constants';
import { AccountCircle, CloseOutlined } from '@material-ui/icons';
import { Avatar, InputAdornment, MenuItem, Select } from '@material-ui/core';
import * as moment from 'moment';
import { primaryColor, webFont } from '../../config/theme';
import { client } from '../../config/apollo';
import { MAKE_PROPOSAL } from '../../graphql/mutations/booking';
import Divider from '@material-ui/core/Divider/Divider';
import { USER_PROFILE } from '../../graphql/queries/user';
import { SelectedChefAvailability } from '../../redux/bookings';
import { GET_CALENDAR_SLOTS } from '../../graphql/queries/schedule';

class FrDateFnsUtils extends DateFnsUtils {
  startOfMonth(date) {
    return moment(date).startOf('month').toDate();
  }

  getDatePickerHeaderText(date) {
    return format(date, 'd MMMM', { locale: this.locale })
  }
}

class Confirmation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      amount                : 100,
      bookingDate           : new Date(),
      decline               : false,
      declineMessage        : '',
      showProposalModal     : false,
      selectedMeridiem      : 'AM',
      selectedTimeHour      : 11,
      selectedTimeMinutes   : '00',
      selectedMeridiemEnd   : 'AM',
      selectedTimeHourEnd   : 11,
      selectedTimeMinutesEnd: '00',
      selectedChefId        : null,
      selectedDate          : null,
      selectedMonth         : null,
      showDatePicker        : false,
      proposalMessage       : '',
      isCounterProposal     : false,
      userProfileDetails    : null,
      monthlySlots          : []
    };
  }

  componentDidMount() {
    if (this.props.booking) {
      const { booking } = this.props;

      this.setState({
        amount             : booking.amount || 200,
        selectedMeridiem   : moment(booking.timeSlot.start, 'hh:mm a').format('A') || 'AM',
        selectedTimeHour   : parseInt(moment(booking.timeSlot.start, 'hh:mm a').format('h')) || 11,
        selectedTimeMinutes: moment(booking.timeSlot.start, 'hh:mm a').format('mm') || '00',
        selectedMeridiemEnd: moment(booking.timeSlot.end, "hh:mm a").format("A") || 'AM',
        selectedTimeHourEnd: parseInt(moment(booking.timeSlot.end, "hh:mm a").format("h")) || 11,
        selectedTimeMinutesEnd: moment(booking.timeSlot.end, "hh:mm a").format("mm") || '00',
        selectedDate: moment(new Date(booking.date)).toDate() || null,
        selectedMonth: moment(new Date(booking.date)).format("MM") || null,
      });
    } else {
      this.props.history.push('/home/chef-bookings?step=1');
    }
  }

  handleSendProposal = () => {
    const payload = {};
    const { booking, chefAvailability, isChef } = this.props;

    const {
      bookingDate, amount, selectedMeridiem,
      selectedTimeHour, selectedTimeMinutes,
      selectedTimeHourEnd, selectedTimeMinutesEnd,
      selectedDate, selectedMonth, proposalMessage,
      selectedMeridiemEnd
    } = this.state;

    if (!bookingDate || !amount || !selectedMeridiem || !selectedTimeHour || !selectedTimeMinutes ||
      !selectedDate || !selectedMonth || !selectedMeridiemEnd || !selectedTimeHourEnd || !selectedTimeMinutesEnd) {
      NotificationManager.error('All fields are mandatory.', 'Proposal');
      return;
    }

    if (parseInt(amount) < 1) {
      NotificationManager.error('Amount cannot be less than 1.', 'Proposal');
      return;
    }

    const convertedDate = moment(selectedDate).format('DD MMM');

    const convertedDateTime = moment(convertedDate + " " +
      `${selectedTimeHour}:${selectedTimeMinutes} ${selectedMeridiem}`, 'DD MMM hh:mm A');

    const convertedDateTimeEnd = moment(convertedDate + " " +
      `${selectedTimeHourEnd}:${selectedTimeMinutesEnd} ${selectedMeridiemEnd}`, 'DD MMM hh:mm A');

    let format = 'HH:mm';
    let chefAvail = false;

    if (typeof chefAvailability === "object" && chefAvailability && !!chefAvailability.length && chefAvailability.length > 0) {
      let startTime = moment(convertedDateTime.format('HH:mm'), format);
      let endTime = moment(convertedDateTimeEnd.format('hh:mm A'), 'hh:mm A');

      chefAvailability.forEach(availableSlot => {
        let beforeTime = moment(availableSlot.start, format),
          afterTime = moment(availableSlot.end, format).add(1, 'minute');

        if ((startTime.isBetween(beforeTime, afterTime) || startTime.isSameOrAfter(beforeTime)) && (endTime.isSameOrBefore(afterTime) || endTime.isBetween(beforeTime, afterTime)) && startTime.isBefore(endTime)) {
          chefAvail = true;
        }
      });
    }

    if (!chefAvail) {
      if (isChef) NotificationManager.error('This slot is not available for booking.', 'Proposal');
      else NotificationManager.error('Chef is not available for the selected slot.', 'Proposal');
      return;
    }

    if (!convertedDateTime.isValid()) {
      NotificationManager.error('Please select a valid date time.', 'Proposal');
      return;
    }

    if (moment().isSameOrAfter(convertedDateTime)) {
      NotificationManager.error('Date cannot be in past', 'Proposal');
      return;
    }

    if (convertedDateTimeEnd.isSameOrBefore(convertedDateTime)) {
      NotificationManager.error('End time cannot be before the start time', 'Proposal');
      return;
    }

    payload.id = booking.id;
    payload.proposedDate = convertedDateTime.format('DD MMM YYYY');
    payload.proposedTime = convertedDateTime.format('HH:mm');
    payload.proposedTimeEnd = convertedDateTimeEnd.format('HH:mm');
    payload.proposedAmount = amount;
    payload.isCounterProposal = this.state.isCounterProposal;

    if (proposalMessage) {
      payload.proposalComments = proposalMessage;
    }

    client.mutate({
        mutation : MAKE_PROPOSAL,
        variables: payload
      })
      .then(response => {
        NotificationManager.info('Proposal sent to diner successfully.', 'Proposal', 4000);
        this.setState({ showProposalModal: false });
        this.props.history.push('/home/chef-bookings');
      })
      .catch(err => {
        console.log('ERR MAKING PROPOSAL: ', err);
        NotificationManager.error('Error making proposal. Please try again.', 'Proposal');
      });
  };

  getUserProfile = userId => {
    client.query({
        query      : USER_PROFILE,
        variables  : { userId },
        fetchPolicy: 'network-only'
      })
      .then(response => {

        if (response.data) {
          if (response.data.userProfile) {
            this.setState({ userProfileDetails: response.data.userProfile });
          }
        }
      })
      .catch(err => {
        console.error('ERR Fetching user profile : ', err);
        this.setState({ userProfileDetails: null });
      });
  };

  openDatePicker = e => {
    this.setState({showDatePicker: !this.state.showDatePicker})
  };

  fetchMonthlySlots = () => {
    if (!this.state.selectedChefId && !this.state.selectedMonth) return;

    client.query({
        query      : GET_CALENDAR_SLOTS,
        variables  : {
          chefId: this.state.selectedChefId,
          start : moment(this.state.selectedMonth, 'MM')
            .startOf('month')
            .format('YYYY-MM-DD'),
          end   : moment(this.state.selectedMonth, 'MM')
            .endOf('month')
            .format('YYYY-MM-DD')
        },
        fetchPolicy: 'network-only'
      })
      .then(response => {
        this.setState({ monthlySlots: response.data })
      })
      .catch(err => console.error('ERROR FETCHING SLOTS FOR THE GIVEN MONTH', this.state.selectedMonth, err));
    this.props.dispatch(SelectedChefAvailability(this.state.selectedChefId, this.state.selectedDate));
  };

  handleMonthChange = date => {
    const updatedMonth = moment(date).format('MM');
    this.setState({ selectedMonth: updatedMonth }, () => {
      this.fetchMonthlySlots();
    });
  };

  isInSchedule = date => {
    const {
      monthlySlots: {getCalendarSlots}
    } = this.state;


    let isAvailable = false;

    if (getCalendarSlots)
      isAvailable = getCalendarSlots.find(day => {
        return day.date === moment(date).format("YYYY-MM-DD");
      });

    return !!isAvailable;
  };

  renderWrappedWeekDay = (date, selectedDate, dayInCurrentMonth, dayComponent) => {
    let inDate = moment(date);
    const inCompDate = inDate.format("YYYY") + "-" + inDate.format("MM") + "-" + inDate.format("DD");
    inDate = moment(inCompDate);
    let today = moment(new Date());
    const compToday = today.format("YYYY") + "-" + today.format("MM") + "-" + today.format("DD");
    today = moment(compToday);

    if (inDate.isBefore(today)) {
      return <Badge>{dayComponent}</Badge>;
    }
    else {
      return <Badge badgeContent={<span
        style={{
          fontSize: 30,
          fontWeight: 500,
          color: this.isInSchedule(date) ? "green" : "white"
        }}
      >
                .
                </span>}>{dayComponent}</Badge>;
    }
  };

  handleDateChange = d => {
    this.setState({
      selectedDate: new Date(d)
    }, () => {
      this.props.dispatch(SelectedChefAvailability(this.state.selectedChefId, this.state.selectedDate));
    });
  };

  render() {
    const { decline } = this.state;
    const { booking, isChef, chefAvailability } = this.props;
    const { status } = booking;
    const minDate = moment().format('YYYY-MM-DD');
    const availability = Array.isArray(chefAvailability) ? chefAvailability.length > 0 ? chefAvailability.map(chefAv => {
      return (`${moment(
        chefAv.start,
        'hh:mm a'
      ).format('LT')}- ${moment(chefAv.end, 'hh:mm a').format(
        'LT'
      )}`);
    }) : [] : [];
    return (
      <Grid container className="confirm-action-col">
        <Grid item md={12}>
          <p style={style.headingText}>Booking confirmation</p>
        </Grid>
        {!!status && status !== 'ACCEPTED' && (
          <Grid container className="booking-action-container">
            <Grid item>
              <Button
                data-test-id={'decbtn'}
                variant={decline ? 'contained' : 'outlined'}
                color={'primary'}
                style={decline ? style.confirmButton : style.declineButton}
                onClick={() => this.setState({ decline: true })}
              >
                Decline
              </Button>
            </Grid>
            {!booking.isCustom && <Grid item>
              <Button
                data-test-id={'acptbtn'}
                variant={!decline ? 'contained' : 'outlined'}
                color={'primary'}
                style={!decline ? style.confirmButton : style.declineButton}
                onClick={() =>
                  this.props.onClick({
                    bookingId: booking.id,
                    status   : BOOKING_STATUS.ACCEPTED
                  })
                }
              >
                Accept
              </Button>
            </Grid>}
            {booking.isCustom && !booking.proposalMade && <Grid item>
              <Button
                data-test-id={'make-proposal-btn'}
                variant="contained"
                color="primary"
                style={style.confirmButton}
                onClick={() => this.setState({
                  showProposalModal: true,
                  selectedMonth: moment(booking.date).format('MM'),
                  selectedChefId: booking.chefId
                }, () => { this.fetchMonthlySlots() })}
              >
                Make Proposal
              </Button>
            </Grid>}
          </Grid>

        )}

        {!!status && status == 'ACCEPTED' ? (
          <Grid container>
            <Grid item md={12}>
              <p style={style.reasonText}>Booking already accepted</p>
            </Grid>
          </Grid>
        ) : ''}

        {decline && (
          <Grid container>
            <Grid item md={12}>
              <p style={style.reasonText}>Reason for decline?</p>
            </Grid>
          </Grid>
        )}
        {decline && (
          <Grid container>
            <Grid item md={11}>
              <TextField
                className="decline-reason-message"
                inputProps={{ 'data-test-id': 'rejreason' }}
                multiline
                rowsMax="4"
                value={booking.rejectReason || this.state.declineMessage}
                fullWidth
                margin="normal"
                variant="standard"
                onChange={evt => {
                  this.setState({ declineMessage: evt.target.value });
                }}
              />
            </Grid>
          </Grid>
        )}
        {decline && (
          <Grid item md={11} style={{ textAlign: 'center', marginTop: 30 }}>
            <Button
              data-test-id={'continuebtn'}

              variant={'outlined'}
              color={'primary'}
              style={style.declineButton}
              onClick={() => {
                if (this.state.declineMessage === '') {
                  NotificationManager.error('Reason is required for rejecting an engagement.', 'Booking');
                  return;
                }
                this.props.onClick({
                  bookingId   : booking.id,
                  status      : BOOKING_STATUS.REJECTED,
                  rejectReason: this.state.declineMessage
                })
              }
              }
            >
              Continue
            </Button>
          </Grid>
        )}

        <Drawer
          open={this.state.showProposalModal}
          anchor={'right'}
        >
          <div style={{ width: 480, padding: '15px 20px 50px', boxSizing: 'border-box' }}>
            <div className="modal-wrapper-booking-transaction-proposal-drawer">
              <div className="modal-close">
                <h3 className="modal-close-header">Make a Proposal</h3>
                <button style={{ border: 'none', background: 'transparent' }}
                        onClick={() => this.setState({ showProposalModal: false, userProfileDetails: null })}>
                  <CloseOutlined/>
                </button>
              </div>

              <Grid container>
                <Grid item xs={12} md={12}>
                  <Grid container className="make-proposal-wrapper">

                    <Grid item xs={12}>
                      <div className="diner-details-time-wrapper booking-slider-inner-wrapper"
                           style={{ marginRight: 0, width: '100%', flexDirection: 'column' }}>
                        <div className="diner-details-date-wrapper" style={{ marginRight: 0, width: '100%' }}>
                          <div style={{
                            display       : 'flex',
                            alignItems    : 'center',
                            marginBottom  : 10,
                            justifyContent: 'space-between'
                          }}>

                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                              {this.state.userProfileDetails ? this.state.userProfileDetails.profilePic ?
                                  <Avatar src={this.state.userProfileDetails ?
                                    this.state.userProfileDetails.profilePic ?
                                      this.state.userProfileDetails.profilePic :
                                      '/images/simple-chef.webp' : '/images/simple-chef.webp'}
                                          style={{ width: 60, height: 60, border: '1px solid #ff8000', marginRight: 5 }}
                                  /> : <AccountCircle style={{ color: '#ff8000', fontSize: 60, marginRight: 5 }}/> :
                                <AccountCircle style={{ color: '#ff8000', fontSize: 60, marginRight: 5 }}/>}
                              <div style={{
                                display       : 'flex',
                                alignItems    : 'flex-start',
                                justifyContent: 'center',
                                flexDirection : 'column'
                              }}>
                                <div style={{
                                  fontSize  : 18,
                                  fontWeight: 500
                                }}>{isChef ? booking.userName : booking.chefName}</div>
                                {isChef && booking.address && <div style={{ fontSize: 12, fontWeight: 400 }}>
                                  {booking.address.city}, {booking.address.state} {booking.address.zipcode}
                                </div>}
                              </div>
                            </div>

                            <div style={{
                              display       : 'flex',
                              alignItems    : 'flex-end',
                              justifyContent: 'center',
                              flexDirection : 'column'
                            }}>
                              <div style={{ fontSize: 16, fontWeight: 500 }}>${booking.startPrice} -
                                ${booking.endPrice}</div>
                              <div style={{ fontSize: 16 }}>
                                <span style={{ fontWeight: 500 }}>Diner(s): </span>{booking.dinerSize}
                              </div>
                            </div>
                          </div>
                        </div>

                        <Divider variant="inset" style={{ margin: 'auto', width: '100%' }}/>

                        <div className="diner-details-date-wrapper"
                             style={{ marginRight: 0, width: '100%', marginTop: 30 }}>
                          <div style={{
                            display       : 'flex',
                            alignItems    : 'center',
                            marginBottom  : 10,
                            justifyContent: 'space-between'
                          }}>
                            <div className="inner-label" style={{
                              fontWeight: 500,
                              textAlign : 'left',
                              fontSize  : 18,
                              fontFamily: webFont
                            }}>Propose Date
                            </div>
                            <div>
                              <MuiPickersUtilsProvider utils={FrDateFnsUtils}>
                                <DatePicker
                                  style={{ color: primaryColor, display: 'none' }}
                                  value={this.state.selectedDate}
                                  animateYearScrolling
                                  // autoOk={true}
                                  onChange={this.handleDateChange.bind(this)}
                                  onMonthChange={this.handleMonthChange}
                                  onAccept={(d) => {
                                    this.openDatePicker();
                                  }}
                                  onClose={() => {
                                    this.openDatePicker();
                                  }}
                                  minDate={moment.isMoment(minDate) ? minDate.toDate() : moment(minDate, 'YYYY-MM-DD').toDate()}
                                  open={this.state.showDatePicker}
                                  renderDay={this.renderWrappedWeekDay}
                                />

                                <Typography
                                  align={'right'}
                                  style={{
                                    fontSize  : 18,
                                    color     : primaryColor,
                                    marginLeft: -5
                                  }}
                                  onClick={this.openDatePicker}
                                >
                                  {moment(this.state.selectedDate).format('DD MMM YYYY')}
                                </Typography>

                              </MuiPickersUtilsProvider>
                            </div>
                          </div>
                        </div>

                        <div className="diner-details-date-wrapper"
                             style={{ marginRight: 0, width: '100%', marginTop: 30 }}>
                          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                            <div className="inner-label" style={{
                              fontWeight: 500,
                              textAlign : 'left',
                              fontSize  : 18,
                              fontFamily: webFont
                            }}>Propose Time
                            </div>
                            <div>
                              <div style={{ marginLeft: -130, fontSize: 14, fontWeight: 500 }}>FROM</div>

                              <Select
                                inputProps={{MenuProps: {disableScrollLock: true}}}
                                className="select-option"
                                data-test-id={'fromhour-id'}
                                value={this.state.selectedTimeHour || moment(booking.timeSlot.start, 'hh:mm a').format('h')}
                                style={{
                                  fontSize  : '18px',
                                  fontWeight: 400,
                                  fontFamily: webFont, marginLeft: 20
                                }}
                                onChange={
                                  evt => this.setState({ selectedTimeHour: evt.target.value })
                                }
                              >
                                {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map(monthDay => (
                                  <MenuItem key={monthDay} value={monthDay} style={{
                                    fontSize  : '18px',
                                    fontWeight: 400,
                                    fontFamily: webFont
                                  }}>
                                    {monthDay < 10 ? `0${monthDay}` : monthDay}
                                  </MenuItem>
                                ))}

                              </Select>
                              <Select
                                inputProps={{MenuProps: {disableScrollLock: true}}}
                                className="select-option"
                                data-test-id={'fromminute-id'}
                                value={this.state.selectedTimeMinutes ? this.state.selectedTimeMinutes :
                                  booking.proposedTime ?
                                  moment(booking.proposedTime, 'HH:mm').format('mm') :
                                  moment(booking.timeSlot.start, 'HH:mm').format('mm')}
                                style={{
                                  fontSize  : '18px',
                                  fontWeight: 400,
                                  fontFamily: webFont, marginLeft: 20
                                }}
                                onChange={
                                  evt => this.setState({ selectedTimeMinutes: evt.target.value })
                                }
                              >
                                {['00', '15', '30', '45'].map(monthDay => (
                                  <MenuItem key={monthDay} value={monthDay} style={{
                                    fontSize  : '18px',
                                    fontWeight: 400,
                                    fontFamily: webFont
                                  }}>
                                    {monthDay}
                                  </MenuItem>
                                ))}
                              </Select>
                              <Select
                                inputProps={{MenuProps: {disableScrollLock: true}}}
                                className="select-option"
                                data-test-id={'frommeridiem-id'}
                                value={this.state.selectedMeridiem ? this.state.selectedMeridiem.trim() : booking.proposedTimeEnd ?
                                  parseInt(moment(booking.proposedTimeEnd, 'HH:mm').format('mm')) :
                                  moment(booking.timeSlot.start, 'HH:mm').format('A')}
                                onChange={
                                  evt => this.setState({ selectedMeridiem: evt.target.value })
                                }
                                style={{
                                  fontSize  : '18px',
                                  fontWeight: 400,
                                  fontFamily: webFont, marginLeft: 20
                                }}
                              >
                                <MenuItem value="AM">AM</MenuItem>
                                <MenuItem value="PM">PM</MenuItem>
                              </Select>
                            </div>
                          </div>
                        </div>

                        <div className="diner-details-date-wrapper"
                             style={{ marginRight: 0, width: '100%', marginTop: 30 }}>
                          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                            <div className="inner-label" style={{
                              fontWeight: 500,
                              textAlign : 'left',
                              fontSize  : 18,
                              fontFamily: webFont
                            }}>{' '}</div>
                            <div>
                              <div style={{ marginLeft: -145, fontSize: 14, fontWeight: 500 }}>TO</div>
                              <Select
                                inputProps={{MenuProps: {disableScrollLock: true}}}
                                className="select-option"
                                data-test-id={'fromhour-id'}
                                value={this.state.selectedTimeHourEnd || moment(booking.timeSlot.end, 'hh:mm a').format('h')}
                                style={{
                                  fontSize  : '18px',
                                  fontWeight: 400,
                                  fontFamily: webFont, marginLeft: 20
                                }}
                                onChange={
                                  evt => this.setState({ selectedTimeHourEnd: evt.target.value })
                                }
                              >
                                {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map(monthDay => (
                                  <MenuItem key={monthDay} value={monthDay} style={{
                                    fontSize  : '18px',
                                    fontWeight: 400,
                                    fontFamily: webFont
                                  }}>
                                    {monthDay < 10 ? `0${monthDay}` : monthDay}
                                  </MenuItem>
                                ))}

                              </Select>
                              <Select
                                inputProps={{MenuProps: {disableScrollLock: true}}}
                                className="select-option"
                                data-test-id={'fromminute-id'}
                                value={this.state.selectedTimeMinutesEnd || moment(booking.timeSlot.end, 'hh:mm a').format('mm')}
                                style={{
                                  fontSize  : '18px',
                                  fontWeight: 400,
                                  fontFamily: webFont, marginLeft: 20
                                }}
                                onChange={
                                  evt => this.setState({ selectedTimeMinutesEnd: evt.target.value })
                                }
                              >
                                {['00', '15', '30', '45'].map(monthDay => (
                                  <MenuItem key={monthDay} value={monthDay} style={{
                                    fontSize  : '18px',
                                    fontWeight: 400,
                                    fontFamily: webFont
                                  }}>
                                    {monthDay}
                                  </MenuItem>
                                ))}
                              </Select>

                              <Select
                                inputProps={{MenuProps: {disableScrollLock: true}}}
                                className="select-option"
                                data-test-id={'frommeridiem-id'}
                                value={this.state.selectedMeridiemEnd || moment(booking.timeSlot.end, 'hh:mm a').format('A')}
                                onChange={
                                  evt => this.setState({ selectedMeridiemEnd: evt.target.value })
                                }
                                style={{
                                  fontSize  : '18px',
                                  fontWeight: 400,
                                  fontFamily: webFont, marginLeft: 20
                                }}
                              >
                                <MenuItem value="AM">AM</MenuItem>
                                <MenuItem value="PM">PM</MenuItem>
                              </Select>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Grid>

                    <Grid item xs={12} style={{ display: 'flex', marginTop: 30, width: '100%', marginBottom: 20 }}>
                      <div className="diner-details-date-wrapper" style={{ marginRight: 0, width: '100%' }}>
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                          <div className="inner-label" style={{
                            fontWeight: 500,
                            width     : 160,
                            textAlign : 'left',
                            fontSize  : 18,
                            fontFamily: webFont
                          }}>Propose Amount
                          </div>
                          <Input
                            name={'amount'}
                            placeholder={'Amount'}
                            label={'Amount'}
                            type={'number'}
                            value={this.state.amount}
                            onChange={(e) => {
                              const val = e.target.value;

                              if (val.length && /^\d+$/.test(val)) {
                                const convertedSize = parseInt(val);
                                if (convertedSize < 1) {
                                  NotificationManager.error('Amount cannot be less than 1', 'Booking');
                                  this.setState({ amount: val });
                                } /*else if (booking.endPrice) {
                                  if (convertedSize < booking.endPrice) {
                                    NotificationManager.error('Amount cannot be more than maximum price', 'Booking');
                                    this.setState({amount: val});
                                  }
                                }*/ else this.setState({ amount: convertedSize });
                              } else {
                                NotificationManager.error('Enter valid number', 'Booking');
                                this.setState({ amount: val });
                              }
                            }}
                            style={{ ...style.inputText, marginLeft: 20, width: 65, textAlign: 'center' }}
                            startAdornment={<InputAdornment position="start">$</InputAdornment>}
                          />
                        </div>
                      </div>
                    </Grid>
                  </Grid>
                </Grid>
                <Divider variant="inset" style={{ margin: 'auto', width: '100%' }}/>
                <div style={{ padding: '20px 0px', fontWeight: 500 }}>
                  {typeof chefAvailability === 'object' && chefAvailability ? `Chef Availability: ${availability.join(' , ')}` : (
                    <FormHelperText id="component-error-text" style={style.error}>
                      {chefAvailability}{' '}
                    </FormHelperText>
                  )}
                </div>
                <Divider variant="inset" style={{ margin: 'auto', width: '100%' }}/>
                <Grid item xs={12} md={12} style={{ display: 'flex', flexDirection: 'column' }}>
                  <p style={{ fontWeight: 500, fontSize: 18, textAlign: 'left' }}>Message</p>
                  <TextField
                    inputProps={{ 'data-test-id': 'pfabtme' }}
                    multiline
                    variant="outlined"
                    rows="5"
                    fullWidth
                    value={this.state.proposalMessage}
                    onChange={evt => {
                      this.setState({ proposalMessage: evt.target.value });
                    }}
                    style={{ ...style.setFont }}
                  />
                </Grid>
              </Grid>

              <Grid container style={{ marginTop: 30, marginBottom: 10, alignItems: 'center' }} justify="center"
                    direction="column">
                <Grid item>
                  <Button
                    data-test-id={'bkgonenext'}
                    style={{ ...style.setFont, ...style.sendButtonStyles }}
                    onClick={this.handleSendProposal}
                  >
                    Send
                  </Button>
                </Grid>
              </Grid>
            </div>
          </div>
        </Drawer>
      </Grid>
    );
  }
}

const mapStateToProps = state => {
  return {
    isChef: state.auth.isChef,
    chefAvailability: state.bookings.chefAvailability,
  };
};

const ConfirmationPage = connect(mapStateToProps)(Confirmation);

export default ConfirmationPage;
